//配置多个baseURL域名的base.js
// alert(process.env.BASE_API)
const base = {
  baseUrl: process.env.BASE_API,// 'http://192.168.0.188:9805/',
  //  baseUrl: 'http://47.118.35.234',
  
  //baseUrl: 'http://51g38p0828.wicp.vip',
  // uploadUrl: 'http://47.118.35.234'
  // baseUrl: 'https://api.mfzcw.com/',
  uploadUrl: process.env.Upload_URL,//'https://api.mfzcw.com/',
  //phoneUrl:'http://192.168.1.198:9806',
  phoneUrl: process.env.PHONE_URL,//'https://api.mfzcw.com/',
  aiPostUrl:process.env.aiPostUrl,
}

export default base;




// WEBPACK FOOTER //
// ./src/request/base.js